var map = {
	"./EffectoLogo.svg": [
		17025,
		7025
	],
	"./Green.svg": [
		4102,
		4102
	],
	"./Money.svg": [
		2298,
		5022
	],
	"./WhiteCheck.svg": [
		79253,
		9253
	],
	"./apple-store-logo.svg": [
		50894,
		3913
	],
	"./appstore.svg": [
		70757,
		757
	],
	"./arrow-drop-down-down.svg": [
		67578,
		7578
	],
	"./arrow-drop-down-right.svg": [
		84515,
		4515
	],
	"./arrow-drop-down-up.svg": [
		66820,
		6820
	],
	"./arrow-left.svg": [
		71169
	],
	"./back-arrow.svg": [
		96181,
		6181
	],
	"./black-friday/gift.svg": [
		79816,
		9816
	],
	"./black-friday/percent-circle.svg": [
		73502,
		3502
	],
	"./black-friday/shipping.svg": [
		93661,
		3661
	],
	"./brand.svg": [
		62562,
		2562
	],
	"./burger-close.svg": [
		17551
	],
	"./burger.svg": [
		12227
	],
	"./call.svg": [
		43160,
		3160
	],
	"./carret.svg": [
		90455,
		455
	],
	"./checkmark-green.svg": [
		76687,
		6687
	],
	"./checkmarks/blue.svg": [
		6304,
		6304
	],
	"./checkmarks/electric.svg": [
		39196,
		9196
	],
	"./checkmarks/green.svg": [
		13479,
		3479
	],
	"./circle-loader.svg": [
		38454
	],
	"./clock.svg": [
		94984,
		4984
	],
	"./cross-circle.svg": [
		59982,
		9982
	],
	"./cross-red.svg": [
		63095,
		3095
	],
	"./default-x.svg": [
		83218,
		3218
	],
	"./discount-black.svg": [
		25047,
		5047
	],
	"./discount-icon.svg": [
		3574,
		3574
	],
	"./dolor-icon.svg": [
		21671,
		1671
	],
	"./exclamation-icon.svg": [
		20688,
		688
	],
	"./exclude-icon.svg": [
		56808,
		6808
	],
	"./facebook.svg": [
		15879
	],
	"./google-play-logo.svg": [
		85687,
		3913
	],
	"./green-check.svg": [
		66876,
		6876
	],
	"./green-circle.svg": [
		60847,
		847
	],
	"./grey-empty-circle.svg": [
		20843,
		843
	],
	"./hide-eye.svg": [
		82932,
		2932
	],
	"./home.svg": [
		13524,
		3524
	],
	"./ico-gplay.svg": [
		54293,
		4293
	],
	"./icons.svg": [
		41921
	],
	"./info-circle-solid.svg": [
		94546,
		5022
	],
	"./instagram.svg": [
		26119
	],
	"./like.svg": [
		17313,
		7313
	],
	"./linkedin.svg": [
		64613,
		4613
	],
	"./location.svg": [
		20863,
		863
	],
	"./lock-solid.svg": [
		75177,
		5022
	],
	"./logo.svg": [
		82190
	],
	"./orange-triangle.svg": [
		89007,
		9007
	],
	"./payment-image.svg": [
		62406,
		5022
	],
	"./payment-methods.svg": [
		1619,
		1619
	],
	"./payments/circle-checked.svg": [
		72970,
		2970
	],
	"./payments/circle-tick-inverted.svg": [
		96122,
		6122
	],
	"./payments/circle-tick.svg": [
		56871
	],
	"./payments/circle-unchecked.svg": [
		28972,
		8972
	],
	"./payments/credit-debit-cards.svg": [
		1309
	],
	"./payments/payment-methods-alt.svg": [
		57912
	],
	"./payments/payment-methods.svg": [
		47019,
		7019
	],
	"./payments/paypal-icon.svg": [
		50704
	],
	"./payments/paypyal-button.svg": [
		44337
	],
	"./payments/secure-footer.svg": [
		2002,
		2002
	],
	"./paypal-image.svg": [
		39653
	],
	"./priceTagLight.svg": [
		43375,
		3375
	],
	"./price_tag-active.svg": [
		38418,
		8418
	],
	"./price_tag-grey.svg": [
		1337,
		1337
	],
	"./prieTagGrey.svg": [
		6322,
		6322
	],
	"./rating.svg": [
		87136,
		7136
	],
	"./recomended-checkout.svg": [
		12249,
		2249
	],
	"./red-x.svg": [
		90627,
		627
	],
	"./reviewStar.svg": [
		19400,
		9400
	],
	"./reviews-stars.svg": [
		58780,
		8780
	],
	"./secure-payments.svg": [
		62494,
		2494
	],
	"./separator.svg": [
		52843,
		2843
	],
	"./show-eye.svg": [
		89533,
		9533
	],
	"./sms.svg": [
		21193,
		1193
	],
	"./social/FB.svg": [
		69443,
		9443
	],
	"./social/IG.svg": [
		63795,
		3795
	],
	"./social/Reddit.svg": [
		80473,
		473
	],
	"./social/Telegram.svg": [
		54827,
		4827
	],
	"./social/TikTok.svg": [
		12276,
		2276
	],
	"./social/Twitter.svg": [
		9055,
		9055
	],
	"./success/arrow-left.svg": [
		60893,
		893
	],
	"./success/arrow-right.svg": [
		39475,
		9475
	],
	"./tick-circle.svg": [
		48892,
		8892
	],
	"./triangle.svg": [
		10727
	],
	"./upgrade/GreenCheck.svg": [
		73282,
		3282
	],
	"./upgrade/check.svg": [
		55457,
		5457
	],
	"./white-percent.svg": [
		1095
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 62873;
module.exports = webpackAsyncContext;